import InputText from "../Form/InputText";
import styles from "./styles.module.css";
import { useState } from "react";

import { auth, database } from "../../services/firebase-config";

import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import AlertModal from "../Layout/AlertModal";
import Loading from "../Loading";

export default function LoginForm() {

    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');

    const [alertModal, setAlertModal] = useState(false);
    const [alertModalTitle, setAlertModalTitle] = useState('Alert');
    const [alertModalMessage, setAlertModalMessage] = useState('Alert Message');

    const [isLoading, setIsLoading] = useState(false);

    let navigate = useNavigate();

    const [user, setUser] = useState({});

    // onAuthStateChanged(auth, (currentUser) => {
    //     setUser(currentUser);
    // });


    async function login(event) {
        event.preventDefault();
        setIsLoading(true);
        try {
            const logUser = await signInWithEmailAndPassword(
                auth,
                userEmail,
                userPassword
            );

            const docRef = await doc(database, 'users', logUser.user.uid)
            const document = await getDoc(docRef);

            if (document.data().admin) {
                navigate('/', { replace: true })
            }
            else {
                setIsLoading(false);
                setAlertModalTitle('Erro');
                setAlertModalMessage('Este usuário não possui permição para acessar esta página');
                setAlertModal(true);
                setTimeout(() => {
                    setAlertModal(false);
                }, 3000)
                signOut(auth);
            }
        }
        catch (error) {
            console.log(error);
            setIsLoading(false);
            setAlertModalTitle('Erro');
            if (error.code === 'auth/invalid-email') {
                setAlertModalMessage('Email não encontrado');

            }
            else if (error.code === 'auth/wrong-password') {
                setAlertModalMessage('Senha incorreta');

            }
            else if (error.code === 'auth/user-not-found') {
                setAlertModalMessage('Usuario não cadastrado');

            }
            else {
                setAlertModalMessage('Email e senha não existem');
            }

            setAlertModal(true);
            setTimeout(() => {
                setAlertModal(false);
            }, 3000)
            signOut(auth);
        }
        setIsLoading(false);
    }


    return (
        <div className={styles.formContainer}>
            {alertModal && <AlertModal title={alertModalTitle} message={alertModalMessage} />}
            {isLoading && <Loading />}
            <form className={styles.loginForm}>
                <InputText value={userEmail} name="Email" setValue={setUserEmail} type="email" required={true} />
                <InputText value={userPassword} name="Senha" setValue={setUserPassword} type="password" required={true} />
                <button onClick={(event) => { login(event); }} className={styles.loginForm__submitButton} type="submit">Acessar</button>
            </form>
        </div>
    );
}